export const SAVE_PORTAL_REGISTRATION = "SAVE_PORTAL_REGISTRATION";
export const SAVE_PORTAL_REGISTRATION_SUCCESS = "SAVE_PORTAL_REGISTRATION_SUCCESS";

export const PORTAL_REGISTRATION_ERROR = "PORTAL_REGISTRATION_ERROR";

export const RESET_PORTAL_REGISTRATION_STATE = "RESET_PORTAL_REGISTRATION_STATE";